<div class="flex-column gap-4">
	<span>
		Reviewers will receive notifications about quarantined email threats sent by your protected mailboxes and will be able to take immediate actions.<br/>
		Reviewers will have access to the following pages: Quarantined Emails, Rules & Policies, Trends and Insights, Reports, and Audit Log.
	</span>
	<div class="list-group list-group-flush settings-list-container">
		<div class="flex-column" style="z-index: 1; max-width: max(65%, 1200px);">
			<!--reviewers table-->
			<trustifi-table-c
				class="trustifi-table" style="flex: 0 0 300px; z-index: 5; overflow: auto;"
				[list]="reviewers"
				[headers]="[
				{text:'Reviewer', sortKey:'email'},
				{text:'View Content', sortKey:'allow_view_content', tooltip: 'Allow reviewer to view the email content for quarantined emails'},
				{text:'Change Configuration', sortKey:'allow_change_configuration', tooltip: 'Allow reviewer to change configurations and settings. If disabled, the reviewer may only review and control emails in quarantine'},
				{text:'Release Email', sortKey:'allow_release_email', tooltip: 'Allow reviewer to release emails from quarantine'},
				{text:'Rules & Policies', sortKey:'rules', tooltip: 'Allow reviewer to manage rules and policies'},
				{text:'Email Signatures', sortKey:'email_signatures', tooltip: 'Allow reviewer to manage email signatures'},
			]"
				[cellsPrototype]="[
				{textKey: 'email', edit: {modelKey: 'email', placeholder: 'Reviewer email'}},
				{html: 'viewContentCell'},
				{html: 'changeConfigCell'},
				{html: 'releaseEmailCell'},
				{html: 'rulesCell'},
				{html: 'emailSignaturesCell'},
			]"
				[bulkActions]="{
				enable: true,
				selectBulkActionCb:	selectMultipleReviewerAction,
				initBulkActionsFunction: showReviewerBulkActions,
				showInRed: {enable: true, terms: ['Remove']}
			}"
				[cellActions] = "{
				enable: true,
				selectItemActionCb:	selectReviewerAction,
				initActionsFunction: showReviewerActions,
				showInRed: {enable: true, terms: ['Remove']}
			}"
				(searchFunction)="searchReviewer($event.searchTerm, $event.activeFilters)"
				(confirmEditFunction)="confirmAddReviewer($event.item, $event.isApproved)"
				[options]="{
				itemsNameSingular: 'reviewer',
				defaultSortKey: '-email',
			}"
			>
				<ng-template #customCells let-item let-cellId="cellId">
					<div *ngIf="cellId === 'viewContentCell'">
						<span [ngStyle]="{color: item.allow_view_content || item.isNew ? 'green' : 'red'}">{{item.allow_view_content || item.isNew ? 'Enabled' : 'Disabled'}}</span>
					</div>
					<div *ngIf="cellId === 'changeConfigCell'">
						<span [ngStyle]="{color: item.allow_change_configuration || item.isNew ? 'green' : 'red'}">{{item.allow_change_configuration || item.isNew ? 'Enabled' : 'Disabled'}}</span>
					</div>
					<div *ngIf="cellId === 'releaseEmailCell'">
						<span [ngStyle]="{color: item.allow_release_email || item.isNew ? 'green' : 'red'}">{{item.allow_release_email || item.isNew ? 'Enabled' : 'Disabled'}}</span>
					</div>
					<div *ngIf="cellId === 'rulesCell'">
						<span [ngStyle]="{color: item.rules || item.isNew ? 'green' : 'red'}">{{item.rules || item.isNew ? 'Enabled' : 'Disabled'}}</span>
					</div>
					<div *ngIf="cellId === 'emailSignaturesCell'">
						<span [ngStyle]="{color: item.email_signatures || item.isNew ? 'green' : 'red'}">{{item.email_signatures || item.isNew ? 'Enabled' : 'Disabled'}}</span>
					</div>

				</ng-template>
				<div tableButtons>
					<div class="btn-with-dropdown">
						<btn-c (action)="startAddReviewer();"
							   endIcon="far fa-plus"
							   [isDisabled]="addReviewerInProcess">
							Add Reviewer
						</btn-c>
						<app-dropdown-c [isLf]="true">
							<li style="text-transform: capitalize; height: auto;"
								(click)="openUsersSelection()">
								Add from my users
							</li>
						</app-dropdown-c>
					</div>
				</div>
			</trustifi-table-c>
		</div>

		<!--Domains/addresses ignore list -->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>Send notifications to specific emails (optional)</b>
				<span style="font-size: 0.9em;">
					Send notification about quarantined email threats <b>only</b> to these recipients.<br/>
					If no address is provided, the information will be sent to the reviewers listed above.
                </span>
			</div>
			<div class="content-container flex-column gap-2">
				<div class="flex-row hSpace05">
					<input type="text" style="width: 80%; max-width: 300px; margin-bottom: unset;"
						   placeholder="Add email address here"
						   (keyup.enter)="addOutboundReviewerRecipient();"
						   [(ngModel)]="customRecipientsModel">
					<btn-c style="min-width: 0;" endIcon="zmdi zmdi-check"
						   [isDisabled]="!customRecipientsModel || customRecipientsActionInProcess"
						   (action)="addOutboundReviewerRecipient();">
					</btn-c>
				</div>
				<div class="flex-column gap-1" style="max-width: 340px;" *ngIf="customRecipients?.length">
					<div *ngFor="let recipient of customRecipients;">
						<div class="name ellipsis" style="width: 95%; display: inline-block; max-width: 800px;">
							{{recipient}}
						</div>
						<a class="closeRed action"
						   (click)="deleteOutboundReviewerRecipient(recipient)"
						   [disabled]="customRecipientsActionInProcess"
						   [ngClass]="customRecipientsActionInProcess ? 'closeRed disableAction' : 'approveGreen'">
							<i class="far fa-times"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<users-selection-component
	*ngIf="usersSelectionPopup?.show"
	[data]="usersSelectionPopup"
	[selectedUsers]="selectedUsers"
	(addCb)="startAddFromUsersSelection($event.users)"
	(removeCb)="startRemoveFromUsersSelection($event.users)">
</users-selection-component>

<popup-c *ngIf="reviewerPermissionPopup?.show"
		 head="Modify Permissions"
		 class="bs-enabled"
		 subTitle="Configure permissions for {{reviewerPermissionPopup.reviewerObj.email}}"
		 (closeCb)="reviewerPermissionPopup = null;"
		 size="dynamic">

	<div class="flxClmn gap-4">
		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>View Content</b>
				<span>Allow reviewer to view the email content for quarantined emails</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="isOutboundReviewer"
								 [hideText]="true"
								 [(model)]="reviewerPermissionPopup.reviewerObj.allow_view_content"
								 (onChange)="reviewerViewContentChangeExecute()"></toggle-switch-c>
			</div>
		</div>

		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>Release Email</b>
				<span>Allow reviewers to release emails from outbound quarantine</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="allow_release_email"
								 [hideText]="true"
								 [(model)]="reviewerPermissionPopup.reviewerObj.allow_release_email"
								 (onChange)="reviewerReleaseEmailExecute()"></toggle-switch-c>
			</div>
		</div>

		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>Change Configuration</b>
				<span>Allow reviewer to change configurations and settings. If disabled, the reviewer may only review and control emails in quarantine</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="allow_change_configuration"
								 [hideText]="true"
								 [(model)]="reviewerPermissionPopup.reviewerObj.allow_change_configuration"
								 (onChange)="reviewerChangeConfigurationExecute()"></toggle-switch-c>
			</div>
		</div>

		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>Rules & Policies</b>
				<span>Allow reviewer to manage rules and policies</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="rules"
								 [hideText]="true"
								 [(model)]="reviewerPermissionPopup.reviewerObj.rules"
								 (onChange)="reviewerRulesChangeExecute()"></toggle-switch-c>
			</div>
		</div>

		<div class="flxRow">
			<div class="flxClmn gap-1" style="width: 450px;">
				<b>Email Signatures</b>
				<span>Allow reviewer to manage email signatures</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="email_signatures"
								 [hideText]="true"
								 [(model)]="reviewerPermissionPopup.reviewerObj.email_signatures"
								 (onChange)="reviewerEmailSignaturesChangeExecute()"></toggle-switch-c>
			</div>
		</div>

	</div>
</popup-c>

